import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import "../styles/components/hamburger.scss";

const Hamburger = ({ state }) => {
  // Create varibles of our dom nodes
  let menu = useRef(null);
  let revealMenu = useRef(null);
  let revealMenuBackground = useRef(null);
  let line1 = useRef(null);
  let line2 = useRef(null);
  let line3 = useRef(null);
  let info = useRef(null);

  useEffect(() => {
    if (state.clicked === false) {
      //close our menu
      gsap.to([revealMenu, revealMenuBackground], {
        duration: 0.8,
        height: 0,
        ease: "power3.inOut",
        stagger: {
          amount: 0.07,
        },
      });
      gsap.to(menu, {
        duration: 1,
        css: { display: "none" },
      });
    } else if (
      state.clicked === true ||
      (state.clicked === true && state.initial === null)
    ) {
      //open our menu
      gsap.to(menu, {
        duration: 0,
        css: { display: "block" },
      });
      gsap.to([revealMenuBackground, revealMenu], {
        duration: 0,
        opacity: 1,
        height: "100%",
      });
      staggerReveal(revealMenuBackground, revealMenu);
      fadeInUp(info);
      staggerText(line1, line2, line3);
    }
  }, [state]);

  const staggerReveal = (node1, node2) => {
    gsap.from([node1, node2], {
      duration: 0.8,
      height: 0,
      transformOrigin: "right top",
      skewY: 2,
      ease: "power3.inOut",
      stagger: {
        amount: 0.1,
      },
    });
  };

  const staggerText = (node1, node2, node3) => {
    gsap.from([node1, node2, node3], {
      duration: 0.8,
      y: 100,
      delay: 0.1,
      ease: "power3.inOut",
      stagger: {
        amount: 0.3,
      },
    });
  };

  const fadeInUp = (node) => {
    gsap.from(node, {
      y: 60,
      duration: 1,
      delay: 0.2,
      opacity: 0,
      ease: "power3.inOut",
    });
  };

  const handleHover = (e) => {
    gsap.to(e.target, {
      duration: 0.4,
      y: 3,
      skewX: 4,
      ease: "power3.inOut",
    });
  };
  const handleHoverExit = (e) => {
    gsap.to(e.target, {
      duration: 0.4,
      y: -3,
      skewX: 0,
      ease: "power3.inOut",
    });
  };

  return (
    <div
      ref={(el) => (menu = el)}
      className="hamburger-menu"
    >
      <div
        ref={(el) => (revealMenuBackground = el)}
        className="menu-secondary-background-color"
      />
      <div
        ref={(el) => (revealMenu = el)}
        className="menu-layer"
      >
        <div className="container">
          <div className="row">
            <div className="menu-links">
              <nav>
                <ul>
                  <li className="no-select">
                    <Link
                      onMouseEnter={(e) => handleHover(e)}
                      onMouseOut={(e) => handleHoverExit(e)}
                      ref={(el) => (line1 = el)}
                      to="solutions"
                    >
                      Solutions
                    </Link>
                  </li>
                  <li className="no-select">
                    <Link
                      onMouseEnter={(e) => handleHover(e)}
                      onMouseOut={(e) => handleHoverExit(e)}
                      ref={(el) => (line2 = el)}
                      to="blogs"
                    >
                      Blogs
                    </Link>
                  </li>
                  <li className="no-select">
                    <Link
                      onMouseEnter={(e) => handleHover(e)}
                      onMouseOut={(e) => handleHoverExit(e)}
                      ref={(el) => (line3 = el)}
                      to="contact"
                    >
                      Contact
                    </Link>
                  </li>
                </ul>
              </nav>
              <div
                ref={(el) => (info = el)}
                className="info"
              >
                <h3>Our Promise</h3>
                <p>
                  Lorem ipsum, or lipsum as it is sometimes
                  known, is dummy text used in laying out
                  print, graphic or web designs. The passage
                  is attributed to an unknown typesetter in
                  the 15th century who is thought to have
                  scrambled parts of Cicero's De Finibus
                  Bonorum et Malorum for use in a type
                  specimen book.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hamburger;
